import { GroupModel } from "../models/Group";
import { User } from "../models/User";
import client from "./axios";

const groupsUrl = `${window.__env.BASE_URL}/groups`;

export const Groups = {
  createGroup: (group: GroupModel) => client.post<GroupModel>(groupsUrl, group),
  updateGroup: (group: GroupModel) => client.put<GroupModel>(`${groupsUrl}/${group.id}`, group),
  getGroups: () => client.get<GroupModel[]>(groupsUrl),
  getGroup: (id: string) => client.get<GroupModel>(`${groupsUrl}/${id}`),
  deleteGroup: (id: number | undefined) => client.delete(`${groupsUrl}/${id}`),
  getGroupMembers: (id: string) => client.get<User[]>(`${groupsUrl}/${id}/members`),
  addGroupMembers: (id: string, members: number[]) => client.put(`${groupsUrl}/${id}/members`, members),
  removeGroupMembers: (id: string, members: number[]) => client.delete(`${groupsUrl}/${id}/members`, { data: members }),
}